import React, { useState, Fragment } from 'react'

import QuickBuy from '@components/Collection/QuickBuy.jsx'
import Price from '@components/Price/Price.jsx'
import QuickBuyIcon from '@components/Icons/QuickBuyIcon.jsx'


import useHover from '@hooks/useHover'

import { splitLastOccurrence } from '@utils/utils'

const RecommendedProduct = ({ product, products, index }) => {
    const item = product

    // console.log('item', item)

    if (item.title.includes('[hidden]')) {
        return null
    }

    let parentProductId = item.tags.find((tag) => {
        if (
            tag.includes('parentProductId') ||
            tag.includes('parentProductID') ||
            tag.includes('parent_product_id') ||
            tag.includes('parentproductid')
        ) {
            return tag
        }
        return null
    })

    parentProductId = parentProductId ? parentProductId.split('_')[1] : null

    const [quickBuyActive, setQuickBuyActive] = useState(false)

    let firstVariantWithInventory = item.variants.find(
        (variant) => variant.inventory_quantity > 0
    )

    let imageUrl = item.images_info?.[0]?.src || ''
    const [before, after] = splitLastOccurrence(imageUrl, '.')
    let resizedImageUrl = before + '_600x900.' + after

    let handle =
        '/products/' +
        item.handle.split('_')[0] +
        '?variant=' +
        firstVariantWithInventory?.id

    const [ref, isHovered] = useHover()

    const handleQuickBuy = () => {
        setQuickBuyActive(!quickBuyActive)
    }

    const handleRecommendedClick = () => {
        va.track('Best Selling Carousel Tile Click', {
            itemType: item.itemType,
            itemName: item.itemName,
            itemLink: item.slug,
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'recommendationClick',
            page: 'pdp',
            ecommerce: {
                currency: 'USD',
                value: firstVariantWithInventory?.price
                    ? firstVariantWithInventory?.price
                    : firstVariantWithInventory?.price_max,
                items: [
                    {
                            item_id: String(firstVariantWithInventory?.id),
                        item_name: product?.title,
                        affiliation: 'Vercel',
                        item_brand: 'Monica + Andy',
                        item_category: firstVariantWithInventory?.initial_color
                            ? firstVariantWithInventory?.initial_color
                            : '',
                        item_category2: firstVariantWithInventory?.initial_size
                            ? firstVariantWithInventory?.initial_size
                            : '',
                            item_variant: String(firstVariantWithInventory?.id) || '',
                        price: Number(firstVariantWithInventory?.price
                            ? firstVariantWithInventory?.price
                            : firstVariantWithInventory?.price_max),
                        quantity: 1,
                    },
                ],
            },
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'GA4_recommendationClick',
            page: 'pdp',
            ecommerce: {
                currency: 'USD',
                value: firstVariantWithInventory?.price
                    ? firstVariantWithInventory?.price
                    : firstVariantWithInventory?.price_max,
                items: [
                    {
                            item_id: String(firstVariantWithInventory?.id),
                        item_name: product?.title,
                        affiliation: 'Vercel',
                        item_brand: 'Monica + Andy',
                        item_category: firstVariantWithInventory?.initial_color
                            ? firstVariantWithInventory?.initial_color
                            : '',
                        item_category2: firstVariantWithInventory?.initial_size
                            ? firstVariantWithInventory?.initial_size
                            : '',
                            item_variant: String(firstVariantWithInventory?.id) || '',
                        price: Number(firstVariantWithInventory?.price
                            ? firstVariantWithInventory?.price
                            : firstVariantWithInventory?.price_max),
                        quantity: 1,
                    },
                ],
            },
        })
    }

    return (
        <div
            ref={ref}
            key={index + '-' + item.id}
            className={`carousel-item recommended-item relative h-auto product-item aspect-[2/3] ${
                firstVariantWithInventory?.id
                    ? firstVariantWithInventory?.id
                    : ''
            }`}
        >
            <div className="product-image relative">
                <a
                    href={handle}
                    className={`h-auto product-item aspect-[2/3] object-cover block bg-origin-padding bg-left-top bg-cover bg-no-repeat z-0 relative hover:opacity-80`}
                    style={{
                        backgroundImage: `url(${resizedImageUrl || ''})`,
                    }}
                    aria-label={`Go to ${
                        item.itemName
                            ? item.itemName + ' category page'
                            : 'category page'
                    }`}
                    onClick={() => {
                        va.track('Best Selling Carousel Tile Click', {
                            itemType: item.itemType,
                            itemName: item.itemName,
                            itemLink: item.slug,
                        })
                    }}
                >
                    <img
                        loading="lazy"
                        src={resizedImageUrl || ''}
                        alt={item.title}
                        className={`w-full product-item aspect-[2/3] object-cover
                                                    `}
                    />
                    <span className="sr-only">
                        {item.itemName ? item.itemName : ''}
                    </span>
                    <span className="sr-only">{item.itemName}</span>
                </a>

                <div
                    className="md:hidden quickbuy-icon-mobile absolute  bottom-3 right-3 bg-white p-2 border border-oat rounded-full "
                    onClick={handleQuickBuy}
                >
                    <QuickBuyIcon width="w-[28px]" />
                </div>

                {isHovered ? (
                    <div className="quickview absolute bottom-[15%] hidden md:block z-50 flex justify-center left-1/2 transform -translate-x-1/2">
                        <button
                            className="quickview-button border border-ash text-ash bg-white uppercase text-sm h-[42px] px-4 min-w-[160px] tracking-wider"
                            onClick={handleQuickBuy}
                        >
                            Quick Buy
                        </button>
                    </div>
                ) : null}

                {quickBuyActive ? (
                    <QuickBuy
                        product={item}
                        products={products}
                        quickBuyActive={quickBuyActive}
                        setQuickBuyActive={setQuickBuyActive}
                        variant={firstVariantWithInventory}
                        variants={item?.variants || []}
                        variantId={firstVariantWithInventory.id}
                        image={resizedImageUrl}
                        handle={handle}
                        type="recommended"
                    />
                ) : null}
            </div>
            <div className="product-details">
                <h3
                    className={`mx-auto text-left my-2 text-base pr-2 line-clamp-2 !leading-[1.3] min-h-[45px]`}
                >
                    <a className="hover:underline" href={handle}>
                        {item.title.replace('_', ' - ')}
                    </a>
                </h3>
                {item.id ? (
                    <div
                        className="bv-inline-rating"
                        data-bv-show="inline_rating"
                        data-bv-product-id={parentProductId ? parentProductId : item.id}
                        data-bv-seo="false"
                    ></div>
                ) : null}

                {/* <div className="product-price text-left mt-2 text-base">
                                                    {item.price_max
                                                        ? '$' +
                                                          convertToCurrency(
                                                              item.price_max
                                                          )
                                                        : ''}
                                                </div> */}
                <Price
                    product={item}
                    matchingVariants={item.variants}
                    priceType="collectionTile"
                />
            </div>
        </div>
    )
}
export default RecommendedProduct
